import { Contact } from "../enums/constants";

export const contactTypes = [
  { id: Contact.TYPE_DESIGNEE, name: 'Information Designee' },
];
